import ListCard from 'components/ListCard'
import { StyledAppContainer } from 'components/Layout/LayoutStyle'
import {
    StyledChatWrapper,
    StyledContainer,
    StyledLeftColumn,
    StyledMainWrapper,
} from 'routes/ChatRouteLayout'
import ListHeader from 'routes/components/ListHeader'
import { useLocation, useNavigate, useOutlet } from 'react-router-dom'
import ColumnListContentLoader from 'components/ContentLoaders/ColumnListContentLoader'

const PlaygroundPage = () => {
    const outlet = useOutlet()
    const navigate = useNavigate()
    const { pathname } = useLocation()

    const fetch_subnets_loading = false

    const subnetsList = [{ id: 18, name: 'Cortex.t', logo: '' }]

    return (
        <StyledAppContainer>
            <StyledContainer>
                <StyledMainWrapper
                // customWidth={'calc(100% - 400px)'}
                >
                    <StyledLeftColumn>
                        {fetch_subnets_loading ? (
                            <>
                                {Array.from({ length: 20 }).map((_, index) => (
                                    <ColumnListContentLoader key={index} />
                                ))}
                            </>
                        ) : (
                            <>
                                <>
                                    <ListHeader title={'Subnets'} />
                                </>
                                {subnetsList.map(subnet => {
                                    return (
                                        <ListCard
                                            key={subnet.id}
                                            onClick={() => navigate(`/playground/${subnet.id}`)}
                                            name={subnet.name}
                                            logo={subnet.logo}
                                            picked={pathname.includes(subnet.id.toString())}
                                        />
                                    )
                                })}
                            </>
                        )}
                    </StyledLeftColumn>
                    <StyledChatWrapper>{outlet}</StyledChatWrapper>
                </StyledMainWrapper>
            </StyledContainer>
        </StyledAppContainer>
    )
}

export default PlaygroundPage
